import { Logo } from 'foundations-components/transitional/components/Logo';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { QuickbooksIcon } from 'foundations-assets/icons/components/QuickbooksIcon';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getPaymentProcessorIcon = value => {
  switch (value) {
    case 'hs_payments':
      return /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "100",
        as: "span",
        children: /*#__PURE__*/_jsx(SprocketIcon, {
          "data-test-id": "processor-icon-hs_payments",
          alignWithText: true,
          color: "fill-brand-default",
          size: '400'
        })
      });
    case 'byo_stripe':
      return /*#__PURE__*/_jsx(Logo, {
        "data-test-id": "processor-icon-byo_stripe",
        name: "stripe",
        width: 18,
        marginInlineEnd: "100"
      });
    case 'quickbooks':
      return (
        /*#__PURE__*/
        // @bend-expect trellis-tokenized this color is the quickbooks logo color
        _jsx("span", {
          style: {
            color: '#2EA048'
          },
          children: /*#__PURE__*/_jsx(Flex, {
            marginInlineEnd: "100",
            alignItems: "center",
            children: /*#__PURE__*/_jsx(QuickbooksIcon, {
              "data-test-id": "processor-icon-quickbooks",
              alignWithText: true,
              size: '400'
            })
          })
        })
      );
    default:
      return null;
  }
};
const FormattedPaymentProcessor = ({
  property,
  value,
  objectTypeId,
  placeholder
}) => {
  useComponentMountMetric('FormattedPaymentProcessor');
  if (value === null || value === undefined) {
    return /*#__PURE__*/_jsx("span", {
      children: placeholder
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [getPaymentProcessorIcon(value), getDisplayedValue(property, value, undefined, undefined, objectTypeId)]
  });
};
export default FormattedPaymentProcessor;